import React from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import UtilsFormule from "../../../utils/UtilsFormule";

const DataTableBordereau = ({ listBordereau }) => {
  function handleTableChange({ bordereau }) {
    return bordereau;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };

  function documentRefFormatter(cell, row) {
    if (row.ref !== null || row.year != null) {
      return (
        <span>
          {row.ref}-{row.year}
        </span>
      );
    } else {
      return <span>-</span>;
    }
  }
  function dateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDate(row.creationDate)}</span>;
  }

  function filePayementFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-gray btn-sm "
        onClick={() => onShowFileInOtherWizndowHandler(row.path)}
      >
        <i class="fas fa-eye"></i>
      </button>
    );
  }

  function detailsPayementFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-dark btn-sm "
        onClick={() => {
          localStorage.setItem("idBordereauDetails", row?.id);
          const pdfWindow = window.open();
          pdfWindow.location.href = "/bordereauDetails";
        }}
      >
        <i class="fas fa-plus"></i>
      </button>
    );
  }
  const columns = [
    {
      dataField: "id",
      text: "",
      align: "center",
      formatter: documentRefFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },

    {
      dataField: "creationDate",
      text: "DC",
      formatter: dateFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },

    {
      dataField: "id",
      text: "Fichier",
      formatter: filePayementFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "id",
      text: "Details",
      formatter: detailsPayementFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
  ];
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les Bordereaux </h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="idPayementInfo"
          data={listBordereau}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>
  );
};
export default DataTableBordereau;
